import * as React from 'react';
import { locale } from '../common/text';

// Google play
// NOTE: all the badges other than 'en' have missaligned letters
// - https://github.com/steverichey/google-play-badge-svg/issues/6
export const APP_BADGE_GOOGLE_PLAY_SUPPORTED_LOCALES = [
  'af',
  'am',
  'ar',
  'az',
  'be',
  'bg',
  'bn',
  'bs',
  'ca',
  'cr',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'es-419',
  'et',
  'eu',
  'fa',
  'fi',
  'fil',
  'fr',
  'fr-ca',
  'gl',
  'gu',
  'hi',
  'hr',
  'hu',
  'hy',
  'id',
  'is',
  'it',
  'iw',
  'ja',
  'ka',
  'kk',
  'km',
  'kn',
  'ko',
  'ky',
  'lo',
  'lt',
  'lv',
  'mk',
  'ml',
  'mn',
  'mr',
  'ms',
  'my',
  'ne',
  'nl',
  'no',
  'pa',
  'pl',
  'pt',
  'pt-br',
  'ro',
  'ru',
  'si',
  'sk',
  'sl',
  'sq',
  'sr',
  'sv',
  'sw',
  'ta',
  'te',
  'th',
  'tr',
  'ua',
  'ur',
  'uz',
  'vi',
  'zh-cn',
  'zh-hk',
  'zh-tw',
  'zu',
];

export const getGooglePlayBadgeLocale = () =>
  APP_BADGE_GOOGLE_PLAY_SUPPORTED_LOCALES.indexOf(locale) > -1 ? locale : 'en';
export const APP_BADGE_GOOGLE_PLAY_PROPS: IAppBadgeProps = {
  img: `img/google-play-badge/${getGooglePlayBadgeLocale()}_get.svg`,
  url: 'https://play.google.com/store/apps/details?id=com.grupet.web.app',
};

// Apple store
export const APP_BADGE_APPLE_STORE_SUPPORTED_LOCALES = ['en', 'de', 'es'];
export const getAppleStoreBadgeLocale = () =>
  APP_BADGE_APPLE_STORE_SUPPORTED_LOCALES.indexOf(locale) > -1 ? locale : 'en';
export const APP_BADGE_PROPS_IOS: IAppBadgeProps = {
  img: `img/apple-store-badge/apple-store-badge-${getAppleStoreBadgeLocale()}.svg`,
  url: 'https://itunes.apple.com/at/app/untis-mobile/id926186904',
};

export interface IAppBadgeProps {
  height?: number;
  img: string;
  url: string;
}

export const AppBadge = ({ height = 40, img, url }: IAppBadgeProps): JSX.Element => (
  <a target="_blank" href={url}>
    <img height={height} src={img} />
  </a>
);



// WEBPACK FOOTER //
// ./src/components/AppBadge.tsx